export const introReducerPath = 'intro';
